module.exports = "<div *ngIf=\"isArchive\" class=\"archive-status\">\n    <div class=\"message\">\n        <div>Eléments supprimés</div>\n    </div>\n</div>\n\n<div class=\"contentPage\" [class.isArchive]=\"isArchive\" [class.listOpen]=\"postitService.isOpen\">\n    <div class=\"list\">\n        <my-buttons [buttons]=\"buttons\"></my-buttons>\n        <my-postit *ngFor=\"let postit of postitService.postitList\" [postit]=\"postit\" (eventDelete)=\"eventDelete($event)\"></my-postit>\n    </div>\n    <div class=\"end\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/postits/postits.component.html
// module id = 753
// module chunks = 1